import { __styles, mergeClasses } from '@griffel/react';
export const carouselSliderClassNames = {
  root: 'fui-CarouselSlider'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "f22iagw",
    Eiaeu8: "f1115ve7"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f1115ve7{overflow-anchor:none;}"]
});
/**
 * Apply styling to the CarouselSlider slots based on the state
 */
export const useCarouselSliderStyles_unstable = state => {
  'use no memo';

  const styles = useStyles();
  state.root.className = mergeClasses(carouselSliderClassNames.root, styles.root, state.root.className);
  return state;
};